import { createHttpEndpoint } from '../../utils'

import type { GetPricingRules, GetPricingRulesMetadata } from '.'

/**
 * Update the reference market and remove merchant's existing pricing rules
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Pricing-Rules/operation/post-bm-merchants-update-reference-market}
 */
export const patchPricingRulesReferenceMarket = createHttpEndpoint({
  method: 'PATCH',
  operationId: 'patch_seller_reference_market',
  path: '/api/seller-experience/pricing-rules/reference-market',
})

/**
 * Retrieves list of pricing rules
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-experience-api/definition}
 */
export const getPricingRules = createHttpEndpoint<GetPricingRules>({
  method: 'GET',
  operationId: 'getMarketPricingRulesRequest',
  path: '/api/seller-experience/pricing-rules',
  transformResponseToCamelCase: true,
})

/**
 * Create a new pricing rule
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-experience-api/definition}
 */
export const postPricingRule = createHttpEndpoint({
  method: 'POST',
  operationId: 'createPricingRule',
  path: '/api/seller-experience/pricing-rules',
  transformRequestToSnakeCase: true,
  transformResponseToCamelCase: true,
})

/**
 * Delete pricing rule object
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-experience-api/definition}
 */
export const deletePricingRule = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deletePricingRule',
  path: '/api/seller-experience/pricing-rules/:ruleId',
})

/**
 * Run a task to apply a pricing_rule
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-experience-api/definition}
 */
export const postPricingRuleRunTask = createHttpEndpoint({
  method: 'POST',
  operationId: 'applyPricingRule',
  path: '/api/seller-experience/pricing-rules/:ruleId/apply',
})

export const getPricingRulesMetadata =
  createHttpEndpoint<GetPricingRulesMetadata>({
    method: 'GET',
    operationId: 'getMarketPricingRulesRequest',
    path: '/api/seller-experience/pricing-rules/metadata',
    transformResponseToCamelCase: true,
  })
